//秒转换成分
var seconds_to_minutes = (time) => {
    var result = parseInt(time / 60.0) +
        "'" +
        parseInt(
            (parseFloat(time / 60.0) -
                parseInt(time / 60.0)) *
            60
        )
    return result
}
export {
    seconds_to_minutes
}